import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-admin-table-toolbar',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, InputTextModule],
  templateUrl: './admin-table-toolbar.component.html',
  styleUrl: './admin-table-toolbar.component.scss',
})
export class AdminTableToolbarComponent {
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() showSearch = false;
  @Input() searchPlaceholderKey = 'COMMON.SEARCH';
  @Input() searchValue = '';

  @Output() searchValueChange = new EventEmitter<string>();

  onSearchInput(value: string): void {
    this.searchValue = value;
    this.searchValueChange.emit(value);
  }
}
